import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  dropdown: {
    marginTop: 32,
    width: '100%!important'
  }
})
